<template>
    <Layout style="height: 100%"
        class="main">
        <Sider class="left-sider"
            hide-trigger
            collapsible
            :width="226"
            :collapsed-width="64"
            v-model="collapsed"
            :style="{overflow: 'hidden'}">
            <side-menu accordion
                ref="sideMenu"
                :active-name="activeMenu.name"
                :collapsed="collapsed"
                @on-select="turnToPage"
                :menu-list="menuList">
                <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
                <div class="logo-con">
                    <img v-show="!collapsed"
                        :src="maxLogo"
                        key="max-logo"
                        @click="toHome" />
                    <img v-show="collapsed"
                        :src="minLogo"
                        key="min-logo"
                        @click="toHome" />
                </div>
            </side-menu>
        </Sider>
        <Layout>
            <Header class="header-con">
                <header-bar :collapsed="collapsed"
                    @on-coll-change="handleCollapsedChange">
                    <user :user-avator="userAvator" />
                    <!-- <language v-if="$config.useI18n" @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local" /> -->
                    <!-- <error-store v-if="$config.plugin['error-store'] && $config.plugin['error-store'].showInHeader" :has-read="hasReadErrorPage" :count="errorCount">
                    </error-store> -->
                    <fullscreen v-model="isFullscreen"
                        style="margin-right: 10px;" />
                    <!-- <notice></notice> -->
                </header-bar>
            </Header>
            <Content class="main-content-con">
                <Layout class="main-layout-con">
                    <div class="tag-nav-wrapper">
                        <tags-nav :value="$route"
                            @input="handleClick"
                            :list="tagNavList"
                            @on-close="handleCloseTag" />
                    </div>
                    <Content class="content-wrapper">
                        <alive-tab>
                            <router-view />
                        </alive-tab>
                    </Content>
                </Layout>
            </Content>
        </Layout>
    </Layout>
</template>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import Fullscreen from './components/fullscreen'
import Language from './components/language'
import Notice from './components/notice'
import config from '@/config'

import ErrorStore from './components/error-store'
import {
    mapMutations,
    mapActions,
    mapGetters
} from 'vuex'
import {
    getNewTagList,
    getNextTag,
    tagEqual,
    deepTraverse
} from '_u/helper'
import './main.less'

import maxLogo from "@/assets/images/logo-long.png"
import minLogo from "@/assets/images/logo-short.png"

export default {
    name: 'Main',
    components: {
        SideMenu,
        HeaderBar,
        Language,
        TagsNav,
        Fullscreen,
        ErrorStore,
        User,
        Notice
    },
    data() {
        return {
            collapsed: false,
            minLogo,
            maxLogo,
            isFullscreen: false
        }
    },
    computed: {
        ...mapGetters([
            'errorCount',
            'cacheList',
        ]),
        tagNavList() {
            return this.$store.state.app.tagNavList
        },
        userAvator() {
            return this.$store.state.user.info.avatar
        },
        menuList() {
            return this.$store.getters.menuList
        },
        local() {
            return this.$store.state.app.local
        },
        hasReadErrorPage() {
            return this.$store.state.app.hasReadErrorPage
        },
        activeMenu() {
            var route = this.$route
            var openedMenus = this.$store.getters.getOpenedMenuList(route)

            return openedMenus[openedMenus.length - 1] || {}
        },
    },
    methods: {
        ...mapMutations([
            'setTagNavList',
            'addTag',
            'setLocal'
        ]),
        ...mapActions([
            'setBreadCrumb',
            'handleLogin'
        ]),
        turnToPage(route) {
            // name
            if (typeof route === 'string') {
                deepTraverse(this.menuList, (node, parent) => {
                    if (node.name == route) {
                        route = node

                        return false
                    }
                })
            }

            if (!route) {
                return
            }

            let { name, params, query } = route

            // action
            if (route.action) {
                let action = route.action

                // 超链接
                if (action.type == "hyperlink") {
                    return window.open(action.href)
                }

                // 全屏
                if (action.type == "fullscreen") {
                    this.isFullscreen = true
                }
            }

            this.$nextTick(() => {
                this.$router.push({
                    name,
                    params,
                    query
                })
            })
        },
        handleCollapsedChange(state) {
            this.collapsed = state
        },
        // tag标签关闭逻辑
        // 无论是关闭单个标签、关闭全部、关闭其它，res都是剩余标签
        handleCloseTag(res, type, route) {
            if (type === 'all' || res.length == 0) {
                this.turnToPage({
                    name: this.$config.homeName
                })
            }
            // 关闭自己时，需要主动跳转到相邻标签
            else if (tagEqual(this.$route, route)) {
                if (type !== 'others') {
                    const nextRoute = getNextTag(this.tagNavList, route)
                    this.$router.push(nextRoute)
                }
            }
            // 同步state
            this.setTagNavList(res)
        },
        handleClick(item) {
            this.turnToPage(item)
        },
        toHome() {
            this.$router.push({
                name: this.$config.homeName,
            })
        }
    },
    watch: {
        '$route'(newRoute, oldRoute) {
            const {
                name,
                query,
                params,
                meta
            } = newRoute

            this.addTag({
                route: {
                    name,
                    query,
                    params,
                    meta
                },
                oldRoute,
                type: this.$store.state.app.routerMethod
            })
            this.setBreadCrumb(newRoute)
            this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
            this.$refs.sideMenu.updateOpenName(newRoute.name)
        }
    },
    mounted() {
        var $route = this.$route
        /**
         * @description 初始化设置面包屑导航和标签导航
         */
        // 面包屑导航
        this.setBreadCrumb(this.$route)
        // 设置初始语言
        if (this.$config.useI18n) {
            this.setLocal(this.$i18n.locale)
        }
        // 导航标签设置
        this.setTagNavList(getNewTagList(this.$rootCache.tagNavList, this.$route))
    }
}
</script>
